require('./bootstrap');


import '../demo4/tools/webpack/vendors/global';
import '../demo4/tools/webpack/scripts';